import React, { useEffect, useState } from 'react';

export const ResellerSupport = () => {
  const [tickets,  setTickets]  = useState([]);
  const [faqs,     setFaqs]     = useState([]);
  const [openFaq,  setOpenFaq]  = useState(null);
  const [form,     setForm]     = useState({ subject: '', category: 'general', message: '' });
  const [loading,  setLoading]  = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [success,  setSuccess]  = useState('');
  const [error,    setError]    = useState('');
 
  useEffect(() => {
    import('./resellerapi').then(({ supportAPI }) => {
      Promise.all([supportAPI.getTickets(), supportAPI.getFAQs()])
        .then(([t, f]) => { setTickets(t.data || []); setFaqs(f.data || []); })
        .catch(e => setError(e.message))
        .finally(() => setLoading(false));
    });
  }, []);
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.message.trim()) { setError('Please describe your issue.'); return; }
    setSubmitting(true); setError('');
    try {
      const { supportAPI } = await import('./resellerapi');
      await supportAPI.submitTicket(form);
      setSuccess('Ticket raised! Our team will respond within 24 hours.');
      setForm({ subject: '', category: 'general', message: '' });
      const t = await supportAPI.getTickets();
      setTickets(t.data || []);
    } catch (e) { setError(e.message); }
    finally { setSubmitting(false); }
  };
 
  const statusClass = (s) => {
    const m = { open: 'pending', resolved: 'delivered', 'in-progress': 'transit' };
    return `status-badge ${m[s] || 'pending'}`;
  };
 
  return (
    <div>
      {error   && <div className="res-error">{error}</div>}
      {success && <div className="res-error" style={{ background: 'rgba(16,185,129,0.1)', borderColor: 'rgba(16,185,129,0.25)', color: 'var(--em-400)' }}>{success}</div>}
 
      <div className="support-grid">
        {/* Left: Raise ticket + FAQs */}
        <div>
          <div className="res-card" style={{ marginBottom: '1.25rem' }}>
            <div className="res-card-title">Raise a Support Ticket</div>
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              <div className="res-input-group" style={{ marginBottom: 0 }}>
                <label className="res-input-label">SUBJECT</label>
                <input
                  className="res-input"
                  type="text"
                  placeholder="Brief subject line"
                  value={form.subject}
                  onChange={e => setForm({ ...form, subject: e.target.value })}
                  required
                />
              </div>
              <div className="res-input-group" style={{ marginBottom: 0 }}>
                <label className="res-input-label">CATEGORY</label>
                <select
                  className="res-input"
                  value={form.category}
                  onChange={e => setForm({ ...form, category: e.target.value })}
                >
                  {['general', 'payment', 'commission', 'order', 'account', 'other'].map(c => (
                    <option key={c} value={c}>{c.charAt(0).toUpperCase() + c.slice(1)}</option>
                  ))}
                </select>
              </div>
              <div className="res-input-group" style={{ marginBottom: 0 }}>
                <label className="res-input-label">DESCRIBE YOUR ISSUE</label>
                <textarea
                  className="res-textarea"
                  placeholder="Tell us what happened..."
                  value={form.message}
                  onChange={e => setForm({ ...form, message: e.target.value })}
                  required
                />
              </div>
              <button className="support-submit-btn" type="submit" disabled={submitting}>
                {submitting ? 'Submitting…' : 'Submit Ticket →'}
              </button>
            </form>
          </div>
 
          <div className="res-card">
            <div className="res-card-title">FAQs</div>
            {faqs.map(f => (
              <div key={f.id} className="faq-item">
                <div className="faq-question" onClick={() => setOpenFaq(openFaq === f.id ? null : f.id)}>
                  {f.question}
                  <span className="faq-toggle">{openFaq === f.id ? '−' : '+'}</span>
                </div>
                {openFaq === f.id && <div className="faq-answer">{f.answer}</div>}
              </div>
            ))}
            {faqs.length === 0 && !loading && (
              <p style={{ color: 'var(--text-3)', fontSize: 13 }}>FAQs loading...</p>
            )}
          </div>
        </div>
 
        {/* Right: Contact + Ticket history */}
        <div>
          <div className="res-card" style={{ marginBottom: '1.25rem' }}>
            <div className="res-card-title">Contact Us</div>
            {[
              { icon: '📱', label: 'WhatsApp Support', val: '+91 98765 43210', href: 'https://wa.me/919876543210' },
              { icon: '📧', label: 'Email Support',    val: 'reseller@atrsolar.in', href: 'mailto:reseller@atrsolar.in' },
              { icon: '⏰', label: 'Support Hours',    val: 'Mon–Sat, 9 AM – 6 PM', href: null },
            ].map(({ icon, label, val, href }) => (
              <div
                key={label}
                className="support-contact-card"
                onClick={() => href && window.open(href, '_blank')}
              >
                <span className="contact-icon">{icon}</span>
                <div>
                  <div className="contact-label">{label}</div>
                  <div className="contact-val">{val}</div>
                </div>
              </div>
            ))}
          </div>
 
          <div className="res-card">
            <div className="res-card-title">My Tickets</div>
            {loading ? (
              <div className="skeleton" style={{ height: 120 }} />
            ) : tickets.length === 0 ? (
              <p style={{ color: 'var(--text-3)', fontSize: 13 }}>No tickets raised yet.</p>
            ) : (
              <div className="res-table-wrap">
                <table className="res-table">
                  <thead>
                    <tr>
                      <th>Ticket</th>
                      <th>Subject</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tickets.map(t => (
                      <tr key={t.id}>
                        <td className="td-primary">#{t.id}</td>
                        <td>{t.subject}</td>
                        <td><span className={statusClass(t.status)}>{t.status}</span></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};


export default ResellerSupport;